import { type CardProduct, type CardStatus } from 'modules/cards/models/cards';
import { getV2ApiCompanyIdCardsTransactionsTransactionId } from 'src/client/spendesk-api';
import type { CurrenciesKey } from 'src/core/config/money';
import { logger } from 'src/utils/datadog-log-wrapper';

export type CardTransactionDetails = {
  card: {
    id: string;
    relatedEntity?:
      | { id: string; type: 'multi_use' }
      | { id: string; type: 'subscription' };
    status: CardStatus;
    type: CardProduct;
  };
  companyId: string;
  currencyAmount: { amount: number; currency: CurrenciesKey };
  declinedReasonsCodes: Array<string>;
  originalCurrencyAmount: { amount: number; currency: CurrenciesKey };
  supplier: { name: string | null; url: string | null } | null;
  supplierName: string;
  transactionDateTime: string;
  transactionId: string;
  transactionStatus: string;
  userId: string;
  user: {
    avatarUrl: string | null;
    email: string | null;
    firstName: string | null;
    id: string;
    lastName: string | null;
  };
};

export const getCardTransactionDetails = async ({
  companyId,
  transactionId,
}: {
  companyId: string;
  transactionId: string;
}): Promise<CardTransactionDetails> => {
  const response = await getV2ApiCompanyIdCardsTransactionsTransactionId({
    path: {
      companyId,
      transactionId,
    },
  });
  if (response.statusCode !== 200) {
    logger.error('Failed to retrieve card transaction details.', {
      error: response.body,
      scope: 'card-transaction-details',
      team: 'cards-ux',
    });
    throw new Error('Failed to retrieve card transaction.');
  }

  return response.body.data as CardTransactionDetails;
};
